import React from 'react';
import { connect } from 'react-redux';
import CandidateProfileContactsTab from '../../Components/CandidateContacts/CandidateProfileContactsTab';
import { getCandidatesConnectInfo } from '../../Reducers/ConnectReducer';
import { getAllMailCount, getMailCount } from '../../Reducers/MailConversationsReducer';
import {
  getAllMessageConversation,
  getMessageConversationOfAllPhoneNumbers,
  getAllMessageConversationCount,
  getMessageConversationOfAllPhoneNumbersCount,
} from '../../Reducers/MessageConversationsReducer';
import { getAllCallConversationsCount, getCallConversationsCount } from '../../Reducers/CallConversationsReducer';
import { getFeatureToggleList } from '../../Reducers/FeatureToggleReducer.ts';
import * as connectActions from '../../Actions/ConnectActions';
import { getApiStatus } from '../../Reducers/ApiStatusReducer';

const mapStateToProps = (state, ownProps) => ({
  connectInfo: getCandidatesConnectInfo(state),
  featureToggleList: getFeatureToggleList(state),
  allContextualMailCount: getAllMailCount(state, ownProps.candidate.PersonId),
  contextualMailCount: getMailCount(state, ownProps.candidate.ConversationId),
  allSmsCount: getAllMessageConversationCount(state, ownProps.candidate.PersonId),
  smsCount: getMessageConversationOfAllPhoneNumbersCount(state, ownProps.candidate.ConversationId),
  candidatesConnectInfo: getCandidatesConnectInfo(state),
  contextualMailsConversationApiStatus: getApiStatus(state, 'setContextualMailsConversationApiStatus'),
  allContextualMailsConversationApiStatus: getApiStatus(state, 'setAllContextualMailsConversationApiStatus'),
  callConversationsCount: getCallConversationsCount(state, ownProps.candidate.ConversationId),
  allCallConversationsCount: getAllCallConversationsCount(state, ownProps.candidate.PersonId),
});

const mapDispatchToProps = {
  fetchMails: connectActions.fetchMails,
  postCallNotes: connectActions.postCallNotes,
  fetchEmailTemplates: connectActions.fetchEmailTemplates,
  resetMails: connectActions.resetMails,
  fetchLatestMessages: connectActions.fetchLatestMessages,
  fetchCalls: connectActions.fetchCalls,
};

function CandidateProfileContactsContainer(props) {
  const {
    connectInfo,
    candidate,
    jobId,
    currentJobDetails,
    jobGuid,
    featureToggleList,
    jobCountryCode,
    postCallNotes,
    toggleBotConfigDrawer,
    candidateContext,
    activeSubTab,
    onSubTabClick,
    version,
    mailRef,
    allMailRef,
    smsRef,
    allSmsRef,
    callRef,
    isCandidateViewHeaderVisible,
    isComposeEmailModalVisible,
    setEmailComposeModalVisibility,
    isComposeMessageModalVisible,
    setMessageComposeModalVisibility,
    currentSelectedEmail,
    setCurrentSelectedEmail,
    phoneNumber,
    setPhoneNumber,
    isMailCommunicationAllowed,
    isMessageCommunicationAllowed,
    openSipCallWindowsApp,
    isContactTabRedirection,
    setCandidateViewHeaderVisibility,
    isConnectIconsEnabled,
    isAudioReadVisible,
    isMessageReadVisible,
    isEmailReadVisible,
    composeEmailType,
    setComposeEmailType,
    contactsTabRef,
    isUnsubscribeCandidateEnabled,
    unsubscribeCandidateButton,
    isComposeWorkflowModalVisible,
    setWorkflowComposeModalVisibility,
    workflowSelectedEmails,
    setWorkflowSelectedEmails,
    fetchEmailTemplates,
    fetchMails,
    allContextualMailCount,
    contextualMailCount,
    candidatesConnectInfo,
    resetMails,
    contextualMailsConversationApiStatus,
    allContextualMailsConversationApiStatus,
    setMessageTab,
    fetchLatestMessages,
    openCandidateView,
    openJobViewInNewTabCallBack,
    setActiveEmailTabKey,
    setActiveSMSTabKey,
    activeEmailTabKey,
    currentEmailPage,
    setCurrentEmailPage,
    currentAllEmailPage,
    setCurrentAllEmailPage,
    allCallConversationsCount,
    callConversationsCount,
    fetchCalls,
    allSmsCount,
    smsCount,
  } = props;
  return (
    <div>
      <CandidateProfileContactsTab
        connectInfo={connectInfo}
        candidate={candidate}
        jobId={jobId}
        currentJobDetails={currentJobDetails}
        jobGuid={jobGuid}
        featureToggleList={featureToggleList}
        jobCountryCode={jobCountryCode}
        postCallNotes={postCallNotes}
        toggleBotConfigDrawer={toggleBotConfigDrawer}
        candidateContext={candidateContext}
        activeSubTab={activeSubTab}
        onSubTabClick={onSubTabClick}
        version={version}
        mailRef={mailRef}
        allMailRef={allMailRef}
        smsRef={smsRef}
        allSmsRef={allSmsRef}
        callRef={callRef}
        isCandidateViewHeaderVisible={isCandidateViewHeaderVisible}
        isComposeEmailModalVisible={isComposeEmailModalVisible}
        setEmailComposeModalVisibility={setEmailComposeModalVisibility}
        isComposeMessageModalVisible={isComposeMessageModalVisible}
        setMessageComposeModalVisibility={setMessageComposeModalVisibility}
        currentSelectedEmail={currentSelectedEmail}
        setCurrentSelectedEmail={setCurrentSelectedEmail}
        phoneNumber={phoneNumber}
        setPhoneNumber={setPhoneNumber}
        isMessageCommunicationAllowed={isMessageCommunicationAllowed}
        isMailCommunicationAllowed={isMailCommunicationAllowed}
        openSipCallWindowsApp={openSipCallWindowsApp}
        isContactTabRedirection={isContactTabRedirection}
        setCandidateViewHeaderVisibility={setCandidateViewHeaderVisibility}
        isConnectIconsEnabled={isConnectIconsEnabled}
        isEmailReadVisible={isEmailReadVisible}
        isAudioReadVisible={isAudioReadVisible}
        isMessageReadVisible={isMessageReadVisible}
        composeEmailType={composeEmailType}
        setComposeEmailType={setComposeEmailType}
        contactsTabRef={contactsTabRef}
        isUnsubscribeCandidateEnabled={isUnsubscribeCandidateEnabled}
        unsubscribeCandidateButton={unsubscribeCandidateButton}
        isComposeWorkflowModalVisible={isComposeWorkflowModalVisible}
        setWorkflowComposeModalVisibility={setWorkflowComposeModalVisibility}
        workflowSelectedEmails={workflowSelectedEmails}
        setWorkflowSelectedEmails={setWorkflowSelectedEmails}
        fetchEmailTemplates={fetchEmailTemplates}
        fetchMails={fetchMails}
        allContextualMailCount={allContextualMailCount}
        contextualMailCount={contextualMailCount}
        candidatesConnectInfo={candidatesConnectInfo}
        resetMails={resetMails}
        contextualMailsConversationApiStatus={contextualMailsConversationApiStatus}
        allContextualMailsConversationApiStatus={allContextualMailsConversationApiStatus}
        setMessageTab={setMessageTab}
        fetchLatestMessages={fetchLatestMessages}
        openCandidateView={openCandidateView}
        openJobViewInNewTabCallBack={openJobViewInNewTabCallBack}
        setActiveEmailTabKey={setActiveEmailTabKey}
        setActiveSMSTabKey={setActiveSMSTabKey}
        activeEmailTabKey={activeEmailTabKey}
        currentEmailPage={currentEmailPage}
        setCurrentEmailPage={setCurrentEmailPage}
        currentAllEmailPage={currentAllEmailPage}
        setCurrentAllEmailPage={setCurrentAllEmailPage}
        allCallConversationsCount={allCallConversationsCount}
        callConversationsCount={callConversationsCount}
        fetchCalls={fetchCalls}
        allSmsCount={allSmsCount}
        smsCount={smsCount}
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CandidateProfileContactsContainer);
